import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import SpecCategory from './SpecCategory';

import '../global-sass/main.scss';

const DetailedSpecs = ({
	prefs,
	specCategories,
	specification,
	widgetInfo,
	isModal
}) => {
	const [isFullWidthLayout, setIsFullWidthLayout] = useState(false);

	const { windowId } = widgetInfo;

	useEffect(() => {
		if (windowId && window && window.document) {
			const widgetAppId = `${windowId}-app-root`;
			const quickSpecsContainer =
				window.document.getElementById(widgetAppId);
			if (quickSpecsContainer?.clientWidth >= 992) {
				setIsFullWidthLayout(true);
			}
		}
	}, []);
	if (specCategories.length === 0 || specification.length === 0) {
		return null;
	}

	return [
		specCategories.map((specCategory) => {
			const { category = '', specIds = [] } = specCategory;
			if (category && specIds.length > 0) {
				return (
					<SpecCategory
						key={category}
						prefs={prefs}
						specCategory={category}
						specification={specification}
						specIds={specIds}
						widgetInfo={widgetInfo}
						isFullWidthLayout={isFullWidthLayout}
						isModal={isModal}
					/>
				);
			}
			return null;
		})
	];
};

DetailedSpecs.propTypes = {
	prefs: PropTypes.objectOf(PropTypes.string),
	specCategories: PropTypes.arrayOf(
		PropTypes.shape({
			category: PropTypes.string,
			specIds: PropTypes.arrayOf(PropTypes.number)
		})
	),
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.shape({}).isRequired
		})
	),
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired,
	isModal: PropTypes.bool
};

DetailedSpecs.defaultProps = {
	prefs: {},
	specCategories: [],
	specification: [],
	isModal: false
};

export default DetailedSpecs;
